import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../Services/translation';
import RangeSlider from './RangeSlider'
import { sliderFilterChange } from '../Actions/FacetedSearch.action'

import {
    submitSearchFacet,
    toggleVisibleDropdownMenu,
} from '../Actions/FacetedSearch.action';

const focusFirstDropdownItem = (groupId) => {
    document
        .getElementById(`facet-filter-list-${groupId}`)
        ?.querySelector(
            'input:not([type="hidden"]), button:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
        ?.focus();
};

const FacetedSearchCompact = ({ facetFilters, onFacetChange }) => {
    const dispatch = useDispatch();
    const { visibleDropdownMenu } = useSelector((state) => state.facetedSearch);

    const handleToggleDropdown = (group) => {
        const isOpen = visibleDropdownMenu.includes(group.id);
        dispatch(toggleVisibleDropdownMenu(group));
        if (!isOpen) {
            setTimeout(() => focusFirstDropdownItem(group.id), 0);
        }
    };

    const handleDropdownKeyDown = (event, group) => {
        if (event.key === 'Escape') {
            event.preventDefault();
            if (visibleDropdownMenu.includes(group.id)) {
                dispatch(toggleVisibleDropdownMenu(group));
                document
                    .getElementById(`facet-filter-trigger-${group.id}`)
                    ?.focus();
            }
        }
    };

    return (
        <ul className="faceted-search faceted-search--compact row">
            {facetFilters &&
                facetFilters.map(
                    (group, groupIndex, array) =>
                        group.options &&
                        group.options.length > 0 && (
                            <li
                                className="columns small-6 large-3 faceted-search__group"
                                key={`${group.label}-${groupIndex}`}
                            >
                                <button
                                    type="button"
                                    id={`facet-filter-trigger-${group.id}`}
                                    className={`faceted-search__group-header ${visibleDropdownMenu.includes(group.id)
                                            ? 'faceted-search__group-header--show-compact'
                                            : ''
                                        }`}
                                    aria-expanded={visibleDropdownMenu.includes(
                                        group.id
                                    )}
                                    aria-controls={`facet-filter-list-${group.id}`}
                                    onClick={() => handleToggleDropdown(group)}
                                >
                                    {group.label}
                                </button>
                                <ul
                                    id={`facet-filter-list-${group.id}`}
                                    role="group"
                                    aria-labelledby={`facet-filter-trigger-${group.id}`}
                                    className={`faceted-search__sublist ${group.id == 'category' ? 'faceted-search__sublist--wide' : ''}`}
                                    onKeyDown={(event) =>
                                        handleDropdownKeyDown(event, group)
                                    }
                                >
                                    {group.isSlider ?
                                        <Fragment>
                                            <div className={`input-range__container`}>
                                                <RangeSlider group={group} sliderFilterChange={(group, values) => dispatch(sliderFilterChange(group, values))} />
                                            </div>
                                        </Fragment>
                                        :
                                        group.options &&
                                        group.options.map(
                                            (item, itemIndex, array) => (
                                                <li
                                                    key={`${item.label}-${itemIndex}`}
                                                    className="faceted-search__item"
                                                >

                                                    <FacetedFilterCheckbox
                                                        item={item}
                                                        group={group}
                                                        onFacetChange={
                                                            onFacetChange
                                                        }
                                                    />
                                                </li>
                                            )
                                        )}
                                    {!group.isSlider &&
                                        <li className="faceted-search__item">
                                            <button
                                                type="button"
                                                className="filter__button"
                                                onClick={(event) => {
                                                    dispatch(
                                                        toggleVisibleDropdownMenu(
                                                            group
                                                        )
                                                    );
                                                    dispatch(
                                                        submitSearchFacet(
                                                            facetFilters
                                                        )
                                                    );
                                                }}
                                            >
                                                {translate('general.select')}
                                            </button>
                                        </li>
                                    }
                                </ul>
                            </li>
                        )
                )}
        </ul>
    );
};

const FacetedFilterCheckbox = ({ item, group, onFacetChange }) => (
    <label className="faceted-filter">
        <input
            className="faceted-filter__input"
            type="checkbox"
            onChange={(event) => onFacetChange(group, item)}
            checked={group.selectedOptions.includes(item.id)}
        />
        <span className="faceted-filter__label">
            <span>
                <span className="faceted-filter__label-text">{item.label}</span>
                {!isNaN(item.quantity) && item.quantity > 0 && (
                    <span className="faceted-filter__quantity">
                        {' '}
                        ({item.quantity})
                    </span>
                )}
            </span>
        </span>
    </label>
);

export default FacetedSearchCompact;
